<template>
  <div style="overflow:hidden;" class="mainbox">
    
    <div class="anliyixiabox">
        <div class="anliyixialeft">
            <div class="anliyixialeftxqbox">
                 <div class="anliyixiatitle"> 
                  <h1>安利只能选十部电影，你应该会喜欢！</h1> 
                  <h6>安利菌：@你蛋掉了 </h6>                
                 </div> 

                 <div class="anliyixiadetailsnrbox">
                    <p>
                      人生必看的5部电影推荐

PS：所谓仁者见仁，智者见智，萝卜青菜各有所爱，以下不乏楼主个人喜好，仅代表个人的观影感受（排名不分先后，图片选自互联网，侵删），欢迎理性交流，谢谢大家！</p>

 <p>一《阿甘正传》 课程：执着</p>



 <p>每次想起阿甘在美国东西海岸之间的奔跑，心里都会止不住的伤感，还有振奋。你相信一个智障儿的成功吗？你相信这世上得到最多的人正是那些不计得失的人吗？阿甘不懂得他不能总跟着一个女人帮她打架，也不懂得一个成年人不该总把他*的话挂在嘴边。阿甘什么都不知道，他只知道凭着直觉在路上不停地跑，并且最终他跑到了终。</p>

 <p>妈妈总说，生命就象一盒巧克力，你从不知盒里会有什么东西。</p>

 <p>Life is like a box of chocolates. You never know what you're gonna get.</p>

 <p>Who is Forrest Gump?</p>

 <p>剧情介绍：</p>


 <p>影片讲述了一个残疾人的非凡一生。50年代的美国，在阿拉巴马州的格林堡镇发生的故事……</p>

 <p>他名叫福雷斯特.甘，家在阿拉巴马州的格林堡镇。40年代他还是个孩子的时候，*着母亲独自抚养，他愚笨，臂上必须佩戴一个表示低能的臂章，但他觉得能理解母亲的每一句话。要上学了，可是当地的公立学校不能接受他，因为他的智商只有75。经过他的亲爱的母亲再三恳求，他才上了学校的车。</p>

 <p>那位唯一愿意让他坐在身旁的女孩子珍妮成了他唯一的朋友。别的孩子则欺负他、捉弄他。这时候，珍妮只好对他说：“快跑，福雷斯特，快1但是他跑不快，他拚命的跑啊，跑，奇迹发生了；他腿上的钢架散落开来，他像出笼的鸟一样飞快地跑了起来……跑啊，跑啊，就这样向前跑。一直到他是个中学生的时候，他也是这样跑着躲避一伙无赖的捉弄，他就这样跑进了一所大学的橄榄球场，从而跑进了大学。橄榄球教练发现了他奔跑的天才，他被破格录龋甘成了橄榄球奇才，受到了肯尼迪总统的接见。</p>

 <p>甘经历了世界风云变幻的历史时期，体验过种种新奇的时尚，但无论他在何处，同谁在一起，他都依然如故。</p>

 <p>在隐居生活中他时常思念着珍妮。而这时的珍妮已误入歧途，陷于绝望。终于有一天，珍妮回来了，他们共同生活了一段时间。最后一晚，珍妮投入了甘的怀抱，然后在黎明时悄悄离去。甘一觉醒来，发现人去楼空，木然坐在走廊里的长椅上，然后，突然，他大步跑到草坪，一直向前跑去。他跑出了镇子，跑出了阿拉巴马州，跑啊，跑啊，跑向路的尽头。他跑出了镇子，跑出了阿拉巴马州，跑向路的尽头，跑到了海边，然后返过身，跑到了另一面的海边。一群的狂热的崇拜者追随着他。</p>

 <p>一向留短发的甘渐渐地须发满面。他数次横穿美国，又一次成了名人。回格林堡镇的途中，他收到了珍妮的来信，在对路人讲述自己的故事。路人告诉他，信上的地址就在附近，走过一两个街区就到了。他二话不说，一把抓起行李，迈开大步向前跑去。珍妮，他又见到了珍妮，而且，见到了一个非常可爱的小男孩。珍妮说，孩子的名字叫福雷斯特。珍妮又对说他，这是你的孩子，甘愣了一下，然后向正在看电视的小福雷斯特跑去。这时的珍妮染上了一种病毒，这是一种不治之症。甘平静地说，跟我回去，我照顾你。三人一同回到了格林堡镇，一起度过了一段幸福的时光。</p>

 <p>之后，珍妮终于永远地离开了甘，而小福雷斯特也到了上学的年龄。甘坐在母亲曾经送他上校车的同一块石头上，看着儿子上了校车，默默地想着什么。一片柔软的羽毛从他脚前飘起，飘向蓝天白云之间。</p>

 <p>阿甘：我答应过布巴，我一直尽量信守诺言。</p>

 <p>阿甘：妈说蠢人就做蠢事。我不是蠢人，我是阿甘。</p>

 <p>《阿甘正传》评析 ：</p>


 <p>在1995 年的第六十七届奥斯卡金像奖最佳影片的角逐中，影片《阿甘正传》一举获得了最佳影片、最佳男主角、最佳导演、最佳改编剧本、最佳剪辑和最佳视觉效果等六项大奖。影片通过对一个智障者生活的描述反映了美国生活的方方面面，从一个独特的角度对美国几十年来社会政治生活中的重要事件作了展现。</p>

 <p>影片改编自温斯顿· 格鲁姆的同名小说。只不过原著是一本充满了讽刺意味的荒诞小说，而影片则对故事进行了修饰和美化。摒弃了原著的荒诞和揭露讽刺意味，为影片增添了一种温情。这无疑使影片更合观众和评委的口味，但却牺牲了原著的叛逆斗争精神，使影片成为了一种理想化道德的象征。</p>

 <p>阿甘在影片中被塑造成了美德的化身，诚实、守信、认真、勇敢而重视感情。在影片中，阿甘是十分纯洁的形象，而珍妮则成了堕落的象征。这与原著有着极大的出入。对于所叙述的一切，影片自始自终都是以一种温情和善意的态度来表现的，甚至还加入了诗意化的成分，这使得影片显得柔和而无伤害性。影片对传统道德观念的宣扬和体现。</p>

<p>使影片变得易为人们所接受，导演高超的编排技巧和电影语言的运用也使影片十分吸引人。影片的内容为影片商业上的成功提供了保证，而导演艺术上的处理也使得影片更加精彩，这就是影片成功的原因所在。《阿甘正传》成了美国当年最为卖座的电影之一。</p>

<p>汤姆·汉克斯在影片中的表演十分朴实自然。他以在此片中的表现获得了奥斯卡最佳男主角的桂冠。这已是他连续获得的第二个影帝金像。《阿甘正传》的成功，也使汤姆·汉克斯成了好莱坞最受欢迎的影星之一。对汤姆·汉克斯来说，那两年是他演艺生涯中最为幸运的一段日子。</p>

<p>二《肖申克的救赎》 课程：信念</p>



<p>“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉。”</p>

<p>一个人能够在十五年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以他成功了，成功夺回了自由。《肖申克的救赎》中有这样一句话：体制化是这样一种东西，一开始你排斥它，后来你习惯它，直到最后你离不开它。想想看，我们的身体已经有多大一部分被体制化了？</p>

<p>行业者安迪，被误判杀妻服刑。在恶棍横行的鲨鱼骨监狱，安迪凭智慧求生存，渐渐赢得监狱长官的倚重和身边监趸的爱戴。可是，他在处理税务报表上的能力换来的是监狱长官要把他永远囚禁的决心。</p>

<p>剧情介绍：</p>


<p>20年的铁窗冤狱，安迪的唯一希望，就在牢房墙壁的大海报后面！</p>

<p>肖申克的监狱的铁门打开。一个身着别扭的旧式西装的老年黑人囚犯走了出来，站在门口他下意识地四处看了看；在明媚的阳光的照耀下，一切是那么地似曾相识，一切又是那么的新鲜。他迟疑了一下，扶了扶头上的帽子，擒起破皮箱向陌生的自由走去。</p>

<p>这是个被关押了40年的囚犯，对自由他早已失望，在监狱中他生活得游刃有余，有很多人需要他。而从这里出去却是一件需要极大勇气的事，因为在真正的现实生活中已没了他的位置，他是个局外人，因为已经被监狱“制度化”了。这是一个近乎完美的囚犯形象，是摩根·佛里曼创造的表演境界。</p>



<p>三《辛德勒的名单》 课程：责任</p>



<p>所谓责任，就是未必做得成却必须去做的事。对于辛德勒来说，救助落难的犹太人是作为一个真正的人的责任。而把那段历史搬上银幕，则是斯皮尔伯格作为一个犹太艺术家的责任。《辛德勒的名单》包含着对受难者的祭奠，对拯救者的敬意，和对光明一定到来的信念。在影片放映后的一片赞誉声中，斯皮尔伯格平静地把影片的全部收益捐给了美国的纳粹大屠杀纪念馆。</p>

<p>剧情介绍：</p>


<p>《辛德勒名单》真实的再现了德国企业家奥斯卡.辛德勒在第二次世界大战期间保护1200名犹太人免法西斯杀害的，真实的历史事件。</p>

<p>德国投机商人辛德勒是个国社党（即纳粹党）党员。他好女色，会享受，是地方上有名的纳粹中坚分子。他善于利用与关系攫取最大的利润。在被占领的波兰，犹太人是最便宜的劳工。因此，辛德勒的工厂只使用犹太人。然而这些人得到这份工作也就得到了暂时的安全，作为战争产品的生产者而免受屠杀。辛德勒的工厂成了犹太人的避难所。</p>

<p>然而纳粹对犹太人的残酷迫害使辛德勒越来越不满。1943年，纳粹对克拉科夫犹太人的残酷血洗使辛德勒对纳粹的最后一点幻想也破灭了，他清楚纳粹对犹太人的屠杀和奥斯威辛集中营的可怖。</p>

<p>从那时起，辛德勒只有一个想法，尽可能多的保护犹太人，使其免受奥斯威辛的死亡。他制定了一份声称工厂正常运转所“必须”的工人名单，通过贿赂纳粹官员，使他们得以幸存下来。</p>

<p>他越来越受到违反种族法的怀疑，但他每次都很机智地躲过了迫害，一如既往地不惜冒着生命危险营救犹太人。当运输他的女工的一列火车错开到奥斯威辛时，他还破费了一大笔财产把这些女工又追回了他的工厂。</p>

<p>不久，苏联红军来到了克拉科夫市，向在辛德勒工厂里干活的幸存的犹太人宣布：战争结束了。下大雪的一天晚上，辛德勒向工人们告别，获救的1000多名犹太人为他送行。</p>

<p>他们把一份自动发起签名的证词交给了辛德勒，以证明他并非战犯。同时，有人还敲下自己的金牙，打制了一枚金戒子，赠送给辛德勒，在戒子上刻着一句犹太人的名言：救人一命就等于救全人类。辛德勒泪流满面，他为未能救出更多的犹太人而感到痛苦。辛德勒为他的救赎行动，已竭尽所能。他的全部财产都已用于挽救犹太人的生命。大雪之中，犹太人目送辛德勒离开了城市。他的义举将永远被犹太人们铭记在心。</p>

<p>评析：</p>


<p>影片《辛德勒名单》是大导演斯蒂芬·斯皮尔伯格于1993年拍摄的一部轰动世界的宏篇巨制。影片深刻地揭露了德国法西斯屠杀犹太人的恐怖罪行，并以其极高的艺术性成为94年全球最为瞩目的一部影片。其思想的严肃性现非凡的艺术表现力都达到了几乎令人难以超越的深度。影片于1993年12月15日在美国上映，当即引起了轰动，获得了金球奖最佳影片奖和最佳导演奖，并获得了美国导演工会奖。</p>

<p>在94年第66届奥斯卡金像奖中《辛德勒名单》一片毫无争议地夺得了最佳影片、最佳导演、最佳改编剧本、最佳艺术指导、最佳摄影以及最佳电影剪辑等6项金像奖。对于影片的成就来说，这是当之无愧的。而斯蒂芬·斯皮尔伯格也以此片第一次夺得了奥斯卡最佳导演奖。对于他的才华来说，这是一份迟到的肯定。</p>

<p>在影片的拍摄过程中，斯蒂芬·斯皮尔伯格投入了巨大的精力和热情，实际上，影片的</p>

<p>改编权和制片权早在1982年就已买下。但直到10年后，影片的拍摄计划才真正得以实行。为了拍摄这部影片，斯皮尔伯格首次放弃了惯用的电影特技，也拒绝请好莱坞影星主演，而是收集了大量的相关资料，请来了当年集中营的幸存者作副导演，并请被辛德勒拯救的犹太人作影片的顾问。斯皮尔伯格耗费了 2300万美元就完成了这部长达3小时15分钟的影片，并谢绝了片酬而将全部个人赢利捐献给美国大屠杀博物馆。</p>

<p>作为一个犹太人，拍摄这样的一部影片也是斯皮尔伯格长期以来的心愿。《辛德勒名单》一片虽然是以黑白摄影为主调，但其制作规模却不亚于任何一部彩色大制作的影片。</p>

<p>影片共有126个角色，动用了3万名临时演员参与演出。影片情节感人，气势悲壮，而以黑白摄影为主调的纪录片式的拍摄手法更使影片具有了一种极其真实的效果，感人肺腑，发人深思。影片中电影语言的运用十分出色，在表现犹太人的悲惨遭遇时，有一个镜头中出现了红色，在冲锋队屠杀犹太人的场景中，穿红衣的小女孩与画面形成了极其强烈的对比，产生了极具艺术冲击力的视觉效果，而当小女孩再次出现时，她已经是运尸车上的一具尸体。这一处理手法堪称经典。同时也点明了主人公思想上所受的冲击。对于辛德勒来说，这一小女孩代表了他所有看见的犹太人的不幸，代表了他心理中发生的变化。这一镜头具有的深层内蕴和艺术价值都是足以载入史册的。它的艺术性达到了经典的地位。</p>

<p>当影片进行到犹太人走出集中营，获得自由时，银幕上骤然间大放光明，出现了灿烂的彩色。这一明显的电影语言技巧的运用，起到了极好的效果。由压抑阴沉的黑白两色到丰富的自然色彩，极其形象地尽显了人们解除死亡危险，重获自由后的开朗心情。此时此刻，几乎每个观众都会不由得鼓起掌来。这既是对犹太人获得自由后的欣慰，也是对导演斯皮尔伯格秘作的最高赞赏。影片的结尾同样具有其感人的艺术魅力。它体现出了犹太人对辛德勒的无限敬意，同时也使影片具有了回顾历史、发人沉思的艺术效果，极大地拓展了影片的表现空间。</p>

<p>《辛德勒名单》一片将作为电影史上永恒的光辉而存在，它是电影史上一部经典的作品。斯蒂芬·斯皮尔伯格的名字也将与这部影片联系在一起而永远流传下去。</p>


<p>四 爱情与责任：《罗马假日》 课程：爱情</p>





<p>也许《罗马假日》有点瞎浪漫的嫌疑，但奥黛丽。赫本的出现使它真的成了一部童话。她就像是游历人间的天使，美丽得不染纤尘。记者吻过湿淋淋的公主，然后看着她慢慢地走向自己的官邸。那一刻，你是否会在心里默默地说，“别走”？在罗马的宫殿里，两个人站得那样近，也离得那样远。乔只能说：“你的朋友绝不会让你失望。”而公主也只能这样回答，“罗马，当然是罗马。”在人的一生里，即便只有这样一刻心灵的相通，也会少却多少遗憾！</p>

<p>奥黛丽.赫本一鸣惊人的处女作，不但当选金像奖影后，并且以其清秀典雅气质在五十年代掀起了“赫本热”，不少女孩模仿其发型服装。就影片的娱乐效果和艺术价值而言，本片也是叫好叫座的经典作。剧情描述英国公主到古都罗马访问，对繁文褥节视为苦事，晚上偷溜到市区欣赏夜色，巧遇善心的美国记者，两人把臂同游，暗生情愫。但英官访问团发现公主失踪，都捏一把冷汗。最后公主为了本身的职责而忍痛牺牲爱情，令人黯然神伤。导演威廉．怀勒以罗马的名胜风光生动地溶入剧情之中，英俊潇洒的格利高里．派克亦与奥黛丽赫本十分登对，将一部浪漫爱情喜剧拍得十分温馨悦目。</p>

<p>五 人生如梦：《美国往事》 课程：人生</p>



<p>《美国往事》包含了一个男人在这个世界上所能遇到的一切。友情、爱情、责任、冲突。它更像是一场让人不愿醒来的梦，当面条躺在床上，在温暖的灯光和的迷离的电话铃声中回到那些逝去了的岁月，这场梦便开始了，直到最后的面条终于露出笑容，我们才回到自己的人生，去继续那些不尽的故事。什么帮派，什么仇杀，原来都不重要，印象中只有一个毛躁的少年，偷看一个美丽女孩儿跳舞；只有一个负罪的兄弟，每天早早地上床睡觉；只有一个白发苍苍的老人，面对背叛了的友谊，语调平和，不动声色。《美国往事》带着你作了一个三小时四十五分钟的梦。人生如梦，这也许是惟一的感受。</p>

<p>这是莱翁内“美国三部曲”之一，是意大利人眼中的20-60年代的美国形象。导演一改好莱坞传统西片的格局，以独特的视角塑造了美国黑社会人出生入死的人物形象。</p>


<p>剧情介绍：

<p>二十年代的美国，绰号“面条”的纽约少年和几个同龄朋友一起认识了聪明狡黠的</p>

<p>麦克斯。他们开始从事走私活动。不久，面条在一场械斗中杀伤人命，被关进监牢。</p>

<p>若干年后面条被释放出狱，当年的小伙伴们已经变成了成熟健壮的青年。在麦克斯的带领下，他们重操旧业，开始了一系列的抢劫、盗窃、敲诈活动。随着犯罪活动的不断深入，麦克斯似乎被胜利冲昏了头脑，竟然把美国联邦储备银行也列入了行动目标。</p>

<p>有过铁窗经验的的面条不忍眼看好友走向毁灭，偷偷打电话报警，想逼迫麦克斯手。警察与面条的朋友展开激烈枪战，麦克斯等人全部被杀。面条在极端的悔恨与痛苦之下，离开了自己生长的地方，离开了心爱的姑娘，远走他乡。</p>

<p>几十年后，几近垂暮的面条潦倒回乡，意外发现原来当年的一切都是麦克斯的精心策划。他借面条和警察之手除去伙伴，自己则金蝉脱壳，吞没了团伙的巨款，改头换面之后跻身政界，成为上层社会的名流。麦克斯恳求面条杀死自己，幻想以此赎回自己的罪孽，，被面条所拒绝。麦克斯走投无路之下跳进垃圾粉碎机自杀。</p>

<p>本片获1984年美国影艺学院最佳陪乐、最佳服饰设计两项奥斯卡金像奖，1985年美国金球奖最佳导演提名。</p>
                   
                 </div>


            <div class="anlipinglunbox">

            <div class="anliyxplbox">
                                <ul>
                                  <li><img :src="anliyxicon01"/><span>255 赞</span></li>
                                  <li><img :src="anliyxicon02"/><span>50 踩</span></li>
                                  <li><img :src="anliyxicon03"/><span>200 快评</span></li>
                                </ul>    
                            </div>  


            <div class="kuaipingbox">
                      <div class="kuaipinglist">
                        <dl>
                          <dt>
                            <span>#1楼</span>@你的大哥哥
                          </dt>
                          <dd>能听懂就行</dd>
                        </dl>
                        <div class="kuaipingping">
                          <ul>
                            <li>
                              <img :src="anliyxicon01" />
                              <span>25 赞</span>
                            </li>
                            <li>
                              <img :src="anliyxicon02" />
                              <span>50 踩</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="kuaipinglist">
                        <dl>
                          <dt>
                            <span>#1楼</span>@你的大哥哥
                          </dt>
                          <dd>能听懂就行</dd>
                        </dl>
                        <div class="kuaipingping">
                          <ul>
                            <li>
                              <img :src="anliyxicon01" />
                              <span>25 赞</span>
                            </li>
                            <li>
                              <img :src="anliyxicon02" />
                              <span>50 踩</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="kuaipinglist">
                        <dl>
                          <dt>
                            <span>#1楼</span>@你的大哥哥
                          </dt>
                          <dd>能听懂就行</dd>
                        </dl>
                        <div class="kuaipingping">
                          <ul>
                            <li>
                              <img :src="anliyxicon01" />
                              <span>25 赞</span>
                            </li>
                            <li>
                              <img :src="anliyxicon02" />
                              <span>50 踩</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="kuaipinghuifu">
                        <ul>
                          <li>
                            <dl>
                              <dt>昵称：</dt>
                              <dd>
                                <Input v-model="formItem.username" placeholder="请输入昵称"></Input>
                              </dd>
                            </dl>
                          </li>
                          <li>
                            <dl>
                              <dt>邮箱：</dt>
                              <dd>
                                <Input v-model="formItem.email" placeholder="请输入邮箱"></Input>
                              </dd>
                            </dl>
                          </li>
                          <li>
                            <Input
                              v-model="formItem.textarea"
                              class="textarea"
                              type="textarea"
                              :autosize="{minRows: 3,maxRows: 8}"
                              placeholder="请输入求安利，求推荐，SOS具体内容..."
                            ></Input>
                          </li>
                          <li>
                            <span>确定发布</span>
                          </li>
                        </ul>
                      </div>
                    </div>  
                </div>


            </div>
        </div>
        <div class="anliyixiaright">

           <Affix :offset-top="92"> 

            <div class="fabubox">
                <dl class="anlitopbtndl">
                    <dt><img :src="anlifbicon"/></dt>
                    <dd>发布安利</dd>                    
                </dl>
            </div>

            <div class="tuijuanbox">
              <h5><em></em>推荐安利</h5>
              <ul>
                  <li>
                    <dl>
                      <dt>安利几款胶片相机app！（大多ios现有15款</dt>
                      <dd>阅读 2,503</dd>
                    </dl>  
                  </li>
                  <li>
                    <dl>
                      <dt>安利一个动画片</dt>
                      <dd>阅读 2,100</dd>
                    </dl>  
                  </li>
                  <li>
                    <dl>
                      <dt>安利些父母看到的动画</dt>
                      <dd>阅读 2300</dd>
                    </dl>  
                  </li>
                  <li>
                    <dl>
                      <dt>安利好吃的牛肉干和四川腊肠～</dt>
                      <dd>阅读 105</dd>
                    </dl>  
                  </li>
                  <li>
                    <dl>
                      <dt>安利乐事气泡薯片系列了....</dt>
                      <dd>阅读 2,5030</dd>
                    </dl>  
                  </li>
              </ul> 
            </div>
             </Affix>

        </div>
    </div>

    <div class="footerbox"></div>
    
    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
export default {
  components: { addweb },
  data() {
    return {
      anlifbicon: require("@/assets/images/fbicon.png"),
      anliyxpic: require("@/assets/images/anliyxpic.jpg"),       
      anliyxicon01: require("@/assets/images/anliyxicon001.gif"),       
      anliyxicon02: require("@/assets/images/anliyxicon002.gif"),   
      anliyxicon03: require("@/assets/images/anliyxicon003.gif"), 
      zxxqanlibg:require("@/assets/images/zxalibox.gif"), 
      zxxqanlisx:require("@/assets/images/shuaxianicon.gif"), 
      qiuanlitop:require("@/assets/images/qaltoppic.gif"), 
      nid:'1',
      formItem: {
          username: '',
          email:'',
          textarea:''         
       }
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {

  },
  methods: {
    gotolabeldetails() {
      this.$router.push({
        name: "labeldetails"
      });
    },
    gotoyiwan(){
        let {href} = this.$router.resolve({name:'yiwan'});
        window.open(href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding-top: 60px;
}
html,
body {
  height: 100%;
}

.anliyixiabox{ width: 1300px; margin: 0 auto; overflow: hidden; padding-bottom: 10px; padding-top: 10px;
    .anliyixialeft{ width: 940px; margin-left: 5px; float: left;   padding-top: 20px;  padding-bottom: 50px; background: #fff; margin-top: 21px; padding: 50px;   padding-top: 39px;box-shadow: 0 0 5px #ddd;  
      

      .anliyixialeftxqbox{

        .anliyixiatitle{ border-bottom: 1px solid #eee; padding-bottom: 18px;
          h1{ font-size:28px;}
          h6{ font-size: 16px; font-weight: normal; padding-top: 8px;}
        }

        .anliyixiadetailsnrbox{ padding-top: 18px;
          p{ font-size: 15px; line-height:26px; padding-bottom: 10px;}
        }

      }


    .anlipinglunbox{

      .anliyxplbox{
          overflow: hidden; padding-bottom: 50px;
          ul{ padding-top: 38px; overflow: hidden;display:flex;
              flex-flow: nowrap row; justify-content: center; align-items: center;
               li{ float: left; padding-right: 20px; cursor: pointer;
                      img{ float: left; margin-top: 3px;}
                      span{ float: left; color: #666; padding-left: 10px; font-size: 16px;;} 
                }
            }
      } 

      .kuaipingbox {
            height: auto;
            border-top: 1px solid #eee;
           
            transition: 1s;
            border-bottom: none;
            clear: both;
            overflow: hidden;
            margin-bottom: 10px; margin-top: 20px;
            .kuaipinglist {
              padding: 15px 20px;
              border-bottom: 1px solid #eee;
              overflow: hidden;
              dl {
                dt {
                  font-weight: bold;
                  font-size: 15px;
                  span {
                    float: right;
                    font-weight: normal;
                    color: #999;
                    font-size: 13px;
                  }
                }

                dd {
                  font-size: 13px;
                  padding-top: 10px;
                }
              }

              .kuaipingping {
                ul {
                  padding-top: 5px;
                  float: right;
                  padding-right: 0px;
                  overflow: hidden;
                  padding-bottom: 10px;
                  li {
                    float: left;
                    padding-left: 30px;
                    img {
                      float: left;
                      margin-top: 1px;
                    }
                    span {
                      float: left;
                      color: #999;
                      padding-left: 10px;
                      font-size: 13px;
                    }
                  }
                }
              }
            }

            .kuaipinghuifu {
              padding-top: 20px;
              padding-bottom: 20px;
              padding-right: 20px;
              border-bottom: 1px solid #eee;
              ul {
                clear: both;
                padding-left: 10px;
                li {
                  clear: both;
                  padding-left: 15px;
                  width: 100%;
                  padding-bottom: 10px;
                  >>> .ivu-input:hover {
                    border-color: #ffa200;
                  }
                  >>> .ivu-input:focus {
                    border-color: #ffa200;
                  }
                  dl {
                    overflow: hidden;
                    dt {
                      float: left;
                      font-size: 13px;
                      padding-top: 6px;
                    }
                    dd {
                      float: left;
                      width: 500px;
                    }
                  }
                  .textarea textarea {
                    height: 60px;
                  }
                  span {
                    display: block;
                    text-align: center;
                    border: 1px solid #e1e1e1;
                    line-height: 35px;
                    background: #f8f8f8;
                    cursor: pointer;
                  }
                }
              }
            }
          }  




    }  

     

    
    }
    .anliyixiaright{ width: 343px; float: right; padding-top: 21px;

      .fabubox{
          background: #f7f7f7; height: 133px; width: 320px; float:right;
         .anlitopbtndl{
              width: 197px; height: 50px; border: 1px solid #ffa200; background: #fff; border-radius: 30px; margin: 0 auto; margin-top: 39px;
              dt{ float: left; padding-left:46px; padding-top:12px;}
              dd{ float: left; font-size: 18px; padding-top:10px; color:#ffa200;padding-left: 10px; }
          } 

      }

      .tuijuanbox{ clear: both;width: 320px; float:right; margin-top: 20px; padding-bottom: 15px; background: #fff;
        h5{  font-size: 17px; padding-left: 15px; padding-left: 10px; padding-top: 18px; padding-left:20px;
          em{
              border-left: 3px solid #ffa200; height: 18px;display: inline-block; padding-right: 10px; float: left; margin-top: 3px;
          }
        }

        ul{
           padding-left: 15px; padding-right: 15px;
           li{ padding-bottom:13px; border-bottom: 1px solid #f3f3f3; padding-top: 13px; margin-left: 10px; padding-right: 5px;
              dl{
                dt{ font-size:14px;overflow:hidden;
text-overflow: ellipsis;
/*-webkit-text-overflow:ellipsis;*/
white-space: nowrap;}
                dd{ font-size: 13px; color: #999; padding-top: 5px;}
              }

           }
        }
      
      }
        
    
    }
}



.footerbox {
  height: 60px;
}


</style>



// WEBPACK FOOTER //
// src/components/pages/anliyixiadetails.vue